import { useNavigate, type ErrorComponentProps } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button, ContentError, EmptyState } from "@core/components";
import { isApiError } from "@core/errors";

/**
 * What the appel routes show when the appel cannot be loaded. `404 appel_not_found` is the normal
 * « not available » state: the appel does not exist OR is outside this account's scope (the API
 * does not tell which, and neither do we). Anything else is the generic failure panel with its
 * retry. Both appear inside the frame.
 */
export function AppelRouteError(props: ErrorComponentProps) {
  const { t } = useTranslation("appels");
  const navigate = useNavigate();

  if (isApiError(props.error) && props.error.status === 404) {
    return (
      <EmptyState
        illustration="empty"
        title={t("not-found.title")}
        description={t("not-found.description")}
        className="min-h-75 justify-center"
        action={
          <Button
            variant="secondary"
            onPress={() => {
              void navigate({ to: "/cohorts" });
            }}
          >
            {t("not-found.back")}
          </Button>
        }
      />
    );
  }

  return <ContentError {...props} />;
}
